import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faRecycle} from '@netx/core-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canRepurposeAsset} from '../enablers';
import {REPURPOSE_ACTION_LABELS} from '../locales';
import {REPURPOSE_EVENT} from './constants';

export const assetRepurposeActionRepurposeIcon = faRecycle;

/**
 * Repurpose asset
 * @param params
 * @returns Action
 */
export const assetRepurposeActionRepurpose = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-repurpose',
	cb: () => dispatcher.trigger(REPURPOSE_EVENT.REPURPOSE_ASSET, asset),
	enableTest: () => canRepurposeAsset(asset),
	icon: assetRepurposeActionRepurposeIcon,
	get label() {
		return REPURPOSE_ACTION_LABELS.REPURPOSE;
	},
	...params,
});

export default assetRepurposeActionRepurpose;
